var _path, _path2, _path3, _path4, _circle, _g, _path5, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMelosCardBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 340 328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "melos-bg_svg__a",
    width: 340,
    height: 328,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121317",
    d: "M0 0h340v328H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#melos-bg_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#121317",
    d: "M0 0h340v328H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#melos-bg_svg__b)",
    d: "M0 0h340v328H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#melos-bg_svg__c)",
    d: "M0 0h340v328H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "melos-bg_svg__d",
    width: 282,
    height: 282,
    x: 250,
    y: -15,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 391,
    cy: 126,
    r: 141,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#melos-bg_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.995,
    cy: -8.005,
    r: 245.995,
    stroke: "url(#melos-bg_svg__f)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__g)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.989,
    cy: -8.006,
    r: 229.865,
    stroke: "url(#melos-bg_svg__h)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__i)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.992,
    cy: -8.004,
    r: 213.734,
    stroke: "url(#melos-bg_svg__j)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__k)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.994,
    cy: -8.008,
    r: 197.603,
    stroke: "url(#melos-bg_svg__l)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__m)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.988,
    cy: -8.005,
    r: 181.472,
    stroke: "url(#melos-bg_svg__n)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__o)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.986,
    cy: -8.007,
    r: 165.341,
    stroke: "url(#melos-bg_svg__p)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__q)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.989,
    cy: -8.007,
    r: 149.21,
    stroke: "url(#melos-bg_svg__r)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__s)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.991,
    cy: -8.007,
    r: 133.08,
    stroke: "url(#melos-bg_svg__t)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__u)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.989,
    cy: -8.004,
    r: 116.949,
    stroke: "url(#melos-bg_svg__v)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__w)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.992,
    cy: -8.004,
    r: 100.818,
    stroke: "url(#melos-bg_svg__x)",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    shapeRendering: "crispEdges"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "melos-bg_svg__z",
    width: 340,
    height: 328,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#melos-bg_svg__y)",
    d: "M0 0h340v328H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#melos-bg_svg__z)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__A)",
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.989,
    cy: 102.131,
    fill: "#7F8AAD",
    rx: 73.989,
    ry: 102.131,
    transform: "matrix(-.87897 .47687 -.51789 -.85545 123.862 48.773)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__B)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.305,
    cy: 31.345,
    fill: "#7F8AAD",
    fillOpacity: 0.8,
    rx: 25.305,
    ry: 31.345,
    transform: "matrix(-.47195 .88162 -.91023 -.4141 48.947 -9.04)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#melos-bg_svg__C)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.305,
    cy: 31.345,
    fill: "#B4BBCF",
    rx: 25.305,
    ry: 31.345,
    transform: "matrix(-.47195 .88162 -.91023 -.4141 48.945 -9.041)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__e",
    width: 493.491,
    height: 494.991,
    x: 133.25,
    y: -254.75,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__g",
    width: 461.229,
    height: 462.729,
    x: 149.375,
    y: -238.621,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__i",
    width: 428.968,
    height: 430.468,
    x: 165.508,
    y: -222.488,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__k",
    width: 396.706,
    height: 398.206,
    x: 181.641,
    y: -206.361,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__m",
    width: 364.444,
    height: 365.944,
    x: 197.766,
    y: -190.227,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__o",
    width: 332.182,
    height: 333.682,
    x: 213.895,
    y: -174.098,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__q",
    width: 299.921,
    height: 301.421,
    x: 230.028,
    y: -157.967,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__s",
    width: 267.659,
    height: 269.159,
    x: 246.162,
    y: -141.836,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__u",
    width: 235.397,
    height: 236.897,
    x: 262.291,
    y: -125.703,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__w",
    width: 203.135,
    height: 204.636,
    x: 278.424,
    y: -109.571,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5717_2050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5717_2050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__A",
    width: 266.061,
    height: 286.896,
    x: -127.096,
    y: -146.759,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2050",
    stdDeviation: 24.6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__B",
    width: 197.875,
    height: 187.63,
    x: -90.464,
    y: -93.525,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2050",
    stdDeviation: 34
  })), /*#__PURE__*/React.createElement("filter", {
    id: "melos-bg_svg__C",
    width: 197.875,
    height: 187.63,
    x: -90.466,
    y: -93.526,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5717_2050",
    stdDeviation: 34
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "melos-bg_svg__f",
    x1: 247.035,
    x2: 107.955,
    y1: 192.084,
    y2: 73.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "melos-bg_svg__h",
    x1: 253.5,
    x2: 182.5,
    y1: 184.5,
    y2: 127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "melos-bg_svg__j",
    x1: 288.5,
    x2: 172.5,
    y1: 183,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "melos-bg_svg__l",
    x1: 273.19,
    x2: 194,
    y1: 152.719,
    y2: 72.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "melos-bg_svg__n",
    x1: 281.903,
    x2: 179.303,
    y1: 139.601,
    y2: 52.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "melos-bg_svg__p",
    x1: 290.619,
    x2: 205,
    y1: 126.479,
    y2: 64.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "melos-bg_svg__r",
    x1: 299.341,
    x2: 227,
    y1: 113.358,
    y2: 53.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "melos-bg_svg__t",
    x1: 308.062,
    x2: 232.822,
    y1: 100.238,
    y2: 36.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "melos-bg_svg__v",
    x1: 316.779,
    x2: 256.5,
    y1: 87.12,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "melos-bg_svg__x",
    x1: 325.5,
    x2: 279,
    y1: 74,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C726D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C726D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "melos-bg_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(161.00015 130.50008 -135.27435 166.89023 16 8.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#373B4A",
    stopOpacity: 0.475
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "melos-bg_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(146.39 156.304 112.951)scale(298.984 161.189)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#634C47",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#402924",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "melos-bg_svg__y",
    width: 0.353,
    height: 0.366,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#melos-bg_svg__D",
    transform: "scale(.00294 .00305)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL0SURBVHgB7drBkYRADEPRzT8DciKn3giGklBzkPu/EzXFzuLDqIzbf3+Yb611/7i+fny+ftyzhOvb/L/ud17C9xxVL4BqD1FwCddu7LiR5UbuJdRyVL0AqoVd6BV8jxtrSoepRPFR9QKo9iIWknhMOtslPHMyxBhZL4BqS3uRV67dztMdMiixdgf3j6wXQLWlvbwncaFEnPsMd/C3R9ULoJrYxSWDBSVS3CjbFYPj6wVQ7UX36B7DuQtsbky5UXxUvQCqiR2ju7GQdJLuhkMSfePrBVBNjIXkKC1ZfnO7Yjeux9cLoJoYTUlH6kaiEmtuN5vMlqvrBVBNjIUtR1fi57vmvUrMjq8XQLWHTk85Mvt69vt1Fz2+XgDVXnSDu47P3KjcNUA4ql4A1R5+8knn6cbdMu93Y80daIypF0C1Zb44h5HodrC7ulZlI2JkvQCqrWyrIbnHjVBlPuzOe8fXC6Dai59/slf8RbTuOv4bWS+Aahtjyh0m7BpKKM//RSxX1Aug2sYuUXnxd+e0bsQl2x0j6wVQTYyI5JhMiTU34pJtiqPqBVBN7PSSo7ckstzIdTvP8fUCqBZ2ocrcNXlhV4YSbhQfVS+Aai9iIYnHpLN158zJUeCYegFUW9qLvHKdbEoke8LJJsb4egFUW/6SmBsXSsS5z3AHf3tUvQCqiV1cMlhQIsWNsl0xOL5eANVedI/uMZy7wObGlBvFR9ULoJrYMbobC0kn6W44JNE3vl4A1cRYSI7SkuU3tyt243p8vQCqidGUdKRuJCqx5nazyWy5ul4A1cRY2HJ0JX6+a96rxOz4egFUe+j0lCOzr2e/X3fR4+sFUO1FN7jr+MyNyl0DhKPqBVDt4SefdJ5u3C3zfjfW3IHGmHoBVFvmi3MYiW4Hu6trVTYiRtYLoNrKthqSe9wIVebD7rx3fL0Aqr34+Sd7xV9E667jv5H1Aqi2MabcYcKuoYTy/F/EckW9AKpt7BKVF393TutGXLLdMbJeDPYPkN6qZhcPlQEAAAAASUVORK5CYII=",
    id: "melos-bg_svg__D",
    width: 120,
    height: 120
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelosCardBg);
export default __webpack_public_path__ + "static/media/melos-card-bg.b04e129f37f10e32d7125e18a15f429a.svg";
export { ForwardRef as ReactComponent };